<template>
	<div class="container d-flex h-screen justify-center align-center">
		<section class="mx-auto text-center" style="max-width: 500px">
			<div class="d-lg-none">
				<IconInline
					class="mx-auto"
					icon="/img/icons/notfound.svg"
					:width="250"
					:height="151" />
			</div>
			<div class="d-none d-lg-block">
				<IconInline
					class="mx-auto"
					icon="/img/icons/notfound.svg"
					:width="500"
					:height="305" />
			</div>
			<h1 class="pr-6 my-12 text-primary">{{ t('common.pageNotFound') }}</h1>
			<div class="mx-auto pr-6">
				<v-btn
					to="/"
					size="large"
					variant="outlined"
					color="#DFE6ED"
					elevation="0"
					block
					class="btn-ani btn-gray">
					{{ t('common.backToHome') }}
				</v-btn>
			</div>
		</section>
	</div>
</template>
